import React from 'react';

import { PDFViewer } from '@react-pdf/renderer';

import { GerarDanfeNfe } from './document';

const RelatorioFc = ({ open, dados }) => (
  <>
    {open && dados && (
      <PDFViewer
        style={{ margin: 0, padding: 0, border: 0 }}
        width="100%"
        height="100%"
      >
        <GerarDanfeNfe objetoXML={dados} />
      </PDFViewer>
    )}
  </>
);

export default RelatorioFc;
